import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRange.css';
import { pl } from 'date-fns/locale';
import DateRangeDisplay from './DateRangeDisplay';
import dateUtils from '../../../helpers/dateUtils';

registerLocale('pl', pl);

const DateRange = ({
                                 onDateRangeUpdated,
                                 minDate,
                                 start,
                                 end,
                                 excludedStartDates,
                                 excludedEndDates,
                                 fromLabel,
                                 toLabel,
                               }) => {
  const [dateRange, setDateRange] = useState([start, end]);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const [startDate, endDate] = dateRange;

  const onChange = (update) => {
    const [start, end] = update;
    if (start && end && end > start) {
      setDateRange([start, end]);
      setOpen(false);
    } else {
      setDateRange(update);
    }
  };

  const clearDates = () => setDateRange([null, null]);

  useEffect(() => {
    onDateRangeUpdated(dateRange);
  }, [dateRange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const popup = wrapper?.querySelector('.calendar-popup');

    if (wrapper && popup) {
      const rect = wrapper.getBoundingClientRect();
      const spaceRight = window.innerWidth - rect.right;
      const popupWidth = popup.offsetWidth;

      if (spaceRight < popupWidth) {
        popup.style.left = `-${popupWidth - rect.width}px`; // shift left
      } else {
        popup.style.left = '0';
      }
    }
  }, [open]);

  return (
    <div className="datepicker-wrapper" ref={wrapperRef}>
      <div className="my-3 search-bar shadow-sm p-0 bg-white rounded-pill d-flex flex-wrap gap-3 align-items-center justify-content-between w-auto">
        <div className="d-flex flex-wrap flex-grow-1 align-items-center gap-3 search-fields w-100">
          <DateRangeDisplay
            startDate={startDate}
            endDate={endDate}
            onClear={clearDates}
            onToggle={() => setOpen((prev) => !prev)}
            isOpen={open}
            fromLabel={fromLabel}
            toLabel={toLabel}
          />
        </div>
      </div>

      {open && (
        <div className="calendar-popup p-2">
          <DatePicker
            locale="pl"
            selected={startDate}
            onChange={onChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            monthsShown={2}
            inline
            minDate={startDate && !endDate ? startDate : minDate}
            maxDate={startDate && !endDate ? dateUtils.getFirstExcludedAfter(startDate, excludedEndDates) : undefined}
            excludeDates={startDate && !endDate ? excludedEndDates : excludedStartDates}
            calendarClassName="custom-calendar"
          />
        </div>
      )}
    </div>
  );
};

export default DateRange;